<template>
    <div class="local_cont"
        :cms_jatekid="param_jatekid"
        :cms_elfogadas="param_elfogadas"
        :cms_lejarat="param_lejarat"
        :cms_lejart_text="param_lejart_text"
        :cms_sikeres_text="param_sikeres_text"
    >
        <GrcDialog2 ref="Dialog2"></GrcDialog2>
        <GrcDB ref="GRCDB"></GrcDB>

        <div class="local_formcont" style="text-align:center; font-weight:bold;" v-show="formid==2" v-html="param_lejart_text">
            
        </div>

        <div class="local_formcont" style="text-align:center; font-weight:bold;" v-show="formid==3" v-html="param_sikeres_text">
            
        </div>

        <div class="local_formcont" v-show="formid==1">
            <div class="local_formcont_col1">

                <GrcNum ref="txtTagkod" v-model="txtTagkod" 
                grc_labeltext="Tagkód:"
                grc_placeholder="..."
                grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                grc_textalign="left"
                grc_labelmode="" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('txtEmailCim');"
                style="margin-bottom:20px;"
                />


                <GrcText ref="txtEmailCim"
                grc_ispassword="false"
                grc_labeltext="E-mail cím:"
                grc_placeholder="..."
                grc_labelmode="" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('txtTelefon');"
                style="margin-bottom:20px;"
                grc_canshowpassword="mobilapp"
                />


                <GrcText ref="txtTelefon"
                grc_ispassword="false"
                grc_labeltext="Telefonszám:"
                grc_placeholder="..."
                grc_labelmode="" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                style="margin-bottom:20px;"
                grc_canshowpassword="mobilapp"
                />

            </div>
            <div class="local_formcont_col2">
                <table class="cms_szolgkeres_felt_chk_table" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkElfogadas" /></td>
                    <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#000;" v-html="elfogadas_text">
                        
                    </td>
                </tr>
                </table>

                <div style="width:100%; box-sizing:border-box; text-align:center; margin:10px 0px;">
                    <span class="cms_linkbutton cms_linkbutton_2" style="vertical-align:top; cursor:pointer;"
                    @click="Mentes"><i class="fas fa-check" style="margin-right:8px;"></i>Regisztrálok</span>                    
                </div>

            </div>

        </div>

    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDialog2 from '../GrcComponents/GrcDialog2.vue'

export default {
  name: 'frmnyeremenyjatek',
  components: {
    GrcDB,
    GrcText,
    GrcNum,
    GrcCheckboxMobile,
    GrcDialog2,

  },
  props: {
    cms_jatekid: String,
    cms_elfogadas: String,
    cms_lejarat: String,
    cms_lejart_text:String,
    cms_sikeres_text:String,
  },

  data () {
        return {
            formid:0,
            txtTagkod:0,
            jatekid:0,
            elfogadas:"",
            elfogadas_text:"",
            param_jatekid: this.cms_jatekid,
            param_elfogadas: this.cms_elfogadas,
            param_lejarat: this.cms_lejarat,
            param_lejart_text: this.cms_lejart_text,
            param_sikeres_text: this.cms_sikeres_text,

        }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmnyeremenyjatek", pCompName);
    },

    async Init()
    {
        this.elfogadas_text = this.GetTextBookItem(this.elfogadas);

        this.param_lejarat = this.param_lejarat.replaceAll(".","-");
        this.param_lejarat = this.param_lejarat.replaceAll(" ","T");

        if (this.param_lejarat == "") { return; }

        let d1 = Date.parse(this.param_lejarat);
        let d2 = Date.now();

        if (d1 < d2)
        {
            this.formid = 2;
            return;
        }


        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData("frmNyeremenyjatek_Init", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT[0].Tagkod > 0)
        {
            this.$refs.txtTagkod.SetValue(Q.RESULT[0].Tagkod);
            this.$refs.txtEmailCim.SetText(Q.RESULT[0].EmailCim);
            this.$refs.txtTelefon.SetText(Q.RESULT[0].Telefon);
        }

        this.formid = 1;

    },

    async ShowDialog(pTitle, pText, pWidth)
    {
      var params = { title: pTitle, text: pText, color: grccomp_dialog_default_color(), width:pWidth,
          buttons: [{text: "Bezárás", value: "OK", color:"cms_linkbutton_OK", width:"100px", default: true}]
      };

      let DialogResult = "";

      await this.$refs.Dialog2.ShowDialog(params).then(res => 
      { 
          DialogResult = res; 
      });               
    },


    async Mentes()
    {
        let d1 = Date.parse(this.param_lejarat);
        let d2 = Date.now();

        if (d1 < d2)
        {
            this.formid = 2;
            return;
        }

        if (this.$refs.chkElfogadas.GetValue() == 0)
        {
            this.ShowDialog("<i class='fal fa-exclamation-circle' style='margin-right:6px;'></i>Információ", "<br>A nyereményjáték feltételeinek elfogadása kötelező!<br><br>", 500);
            return;
        }

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iJatekID: this.jatekid,
            iTagkod: this.$refs.txtTagkod.GetValue(),
            sEmailCim: this.$refs.txtEmailCim.GetText().trim(),
            sTelefon: this.$refs.txtTelefon.GetText().trim(),
        };


        var Q;
        await this.$refs.GRCDB.GetData("frmNyeremenyjatek_Mentes", QP).then(res => { Q = res; });

        this.$refs.GRCDB.HideLoading();

        if (Q.APPERR[0].ERR != "")
        {
            this.ShowDialog("<i class='fal fa-exclamation-circle' style='margin-right:6px;'></i>Információ", "<br>"+Q.APPERR[0].ERR+"<br><br>", 500);
            return;
        }

        this.formid = 3;


        //window.scrollTo(0, this.$refs.liststart.offsetTop - 60);


    },

  },
  created()
  {
    if (typeof this.param_jatekid == "undefined")
    {
      this.param_jatekid = "0";
    }

    this.jatekid = parseInt(this.param_jatekid);


    if (typeof this.param_elfogadas == "undefined")
    {
      this.param_elfogadas = "";
    }

    this.elfogadas =this.param_elfogadas;

    if (typeof this.param_lejarat == "undefined")
    {
      this.param_lejarat = "";
    }

    if (typeof this.param_lejart_text == "undefined")
    {
      this.param_lejart_text = "";
    }

    if (typeof this.param_sikeres_text == "undefined")
    {
      this.param_sikeres_text = "";
    }


  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>

.local_cont
{
    width:100%;
    box-sizing: border-box;
    text-align: left;
    background-color: #f0f1f2;
    padding: 10px;
    border-radius: 10px;    
}

.local_formcont
{
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    padding: 10px 0px;
    margin:10px 0px;
}

.local_formcont_col1
{
    width: 50%;
    display: inline-block;
    padding:0px 20px 0px 10px;
    text-align: left;
    vertical-align: top;    
}

.local_formcont_col2
{
    width: 50%;
    display: inline-block;
    padding:0px 10px 0px 20px;
    text-align: left;
    vertical-align: top;    
    border-left: dashed 2px #ccc;

}

@media (max-width:800px)
{
    .local_cont
    {
        padding: 0px;
    }

    .local_formcont_col1
    {
        width: 100%;
        padding:8px;
    }    

    .local_formcont_col2
    {
        width: 100%;
        padding:8px;
        border:none;
    }    

}
</style>
